import React from "react";
import { Container } from "reactstrap";
import CreateFormInput from "../CreateFormInput";
import { colors } from "../../Utils/Colors";
import { serverUrls } from "../../Utils/Urls";
import {
  getScans,
  getScansFailure,
  getScansSuccess,resetScanState
} from "../../Actions/patientAction";
import { connect } from "react-redux";
import axios from "axios";

const formInputs = {
  boneScanNo: {
    type: "text",
    placeholder: "Bone Scan No.",
    label: "Bone Scan No.",
  },
  boneScanImpression: {
    type: "text",
    placeholder: "Bone Impression",
    label: "Bone Impression",
  },
  boneScanPdf: {
    type: "upload",
    placeholder: "Bone Scan Pdf",
    label: "Bone Scan Pdf",
  },
  usgScanNo: {
    type: "text",
    placeholder: "USG Scan No.",
    label: "USG Scan No.",
  },
  usgScanImpression: {
    type: "text",
    placeholder: "USG Impression",
    label: "USG Impression",
  },
  usgScanPdf: {
    type: "upload",
    placeholder: "usg Scan Pdf",
    label: "USG Scan Pdf",
  },
  petScanNo: {
    type: "text",
    placeholder: "PET Scan No.",
    label: "PET Scan No.",
  },
  petScanImpression: {
    type: "text",
    placeholder: "PET Impression",
    label: "PET Impression",
  },
  petScanPdf: {
    type: "upload",
    placeholder: "Pet Scan Pdf",
    label: "PET Scan Pdf",
  },
  mriScanNo: {
    type: "text",
    placeholder: "MRI Scan No.",
    label: "MRI Scan No.",
  },
  mriScanImpression: {
    type: "text",
    placeholder: "MRI Impression",
    label: "MRI Impression",
  },
  mriScanPdf: {
    type: "upload",
    placeholder: "MRI Pdf",
    label: "MRI Pdf",
  },
  twodEchoScanNo: {
    type: "text",
    placeholder: "2D ECHO Scan No.",
    label: "2D ECHO Scan No.",
  },
  twodEchoScanImpression: {
    type: "text",
    placeholder: "2D ECHO Impression",
    label: "2D ECHO Impression",
  },
  twoEchoScanPdf: {
    type: "upload",
    placeholder: "2D Echo Pdf",
    label: "2D Echo Pdf",
  },
  pathologyBiopsyNo: {
    type: "text",
    placeholder: "Pathology Biopsy no",
    label: "Biopsy no",
  },
  pathologyImpression: {
    type: "text",
    placeholder: "Pathology Impression",
    label: "Pathology Impression",
  },
  pathologyScanPdf: {
    type: "upload",
    placeholder: "Pathology Pdf",
    label: "Pathology Pdf",
  },
  otherScanNo: {
    type: "text",
    placeholder: "Other Scan No.",
    label: "Other Scan No.",
  },
  otherScanImpression: {
    type: "text",
    placeholder: "Other Impression",
    label: "Other Impression",
  },
  otherScanPdf: {
    type: "upload",
    placeholder: "Other Scan Pdf",
    label: "Other Scan Pdf",
  },
};

class Scans extends React.Component {
  componentDidMount() {
    this.props.getScansEdit(serverUrls.scans + this.props.id + "/");
  }
  componentWillUnmount() {
    this.props.resetScanState();
  }

  render() {
    var url = serverUrls.scans + this.props.id + "/";
    return (
      <Container style={{ maxWidth: 800, background: colors.lightGrey }}>
        <br />
        <h4>Scans</h4>
        <br />
        <CreateFormInput
          isPost={false}
          buttonName="Save"
          url={url}
          formName="getScans"
          inputs={formInputs}
        />
        <br />
        <br />
      </Container>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScansEdit: (url) => {
      dispatch(getScans({ loading: true }));
      axios
        .get(url)
        .then((res) => {
          dispatch(
            getScansSuccess({
              loading: false,
              success: res.data.success,
              data: res.data,
            })
          );
        })
        .catch((err) => {
          dispatch(getScansFailure({ loading: false }));
        });
    },
    resetScanState: () => {
      dispatch(resetScanState());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Scans);
